const ROMAN_NUMBER: Record<number, string> = {
    1: 'I',
    2: 'II',
    3: 'III'
};

export const convertToRomanNumerals = (input: string) => {
    return input.replace(/\b(1|2|3)\b/g, (match) => {
        return ROMAN_NUMBER[Number(match)] || match;
    });
};
